import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button, Typography } from '@material-ui/core';
import {
  BorderColor, CheckBox, InfoOutlined, RadioButtonChecked, Notes,
} from '@material-ui/icons';
import messages from '../messages';

const S = {
  Wrapper: styled.div`
    padding-bottom: 8px;
  `,
  HelperText: styled(Typography)`
    margin-bottom: 32px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    font-weight: 700;
  `,
  Flexbox: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 32px;
  `,
  Button: styled(Button).attrs({ type: 'button' })`
    min-height: 50px;
    border-color: ${({ theme }) => theme.palette.grey[300]};
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    :not(:last-child) {
      margin-bottom: 8px;
    }
    :hover {
      border-width: 2px;
      border-color: ${({ theme }) => theme.palette.primary.light};
      color: ${({ theme }) => theme.palette.primary.light};
      background-color: transparent;
      font-weight: 700;
      svg {
        color: ${({ theme }) => theme.palette.primary.light};
      }
    }
  `,
  RadioButtonChecked: styled(RadioButtonChecked)`
    margin-right: 16px;
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    color: ${({ theme }) => theme.palette.grey[500]};
  `,
  CheckBox: styled(CheckBox)`
    margin-right: 16px;
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    color: ${({ theme }) => theme.palette.grey[500]};
  `,
  Notes: styled(Notes)`
    margin-right: 16px;
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    color: ${({ theme }) => theme.palette.grey[500]};
  `,
  BorderColor: styled(BorderColor)`
    margin-right: 16px;
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    color: ${({ theme }) => theme.palette.grey[500]};
  `,
  Note: styled(Typography)`
    display: flex;
    align-items: flex-start;
  `,
  InfoOutlined: styled(InfoOutlined)`
    margin-right: 4px;
    color: ${({ theme }) => theme.palette.status.info};
    font-size: 1rem;
  `,
  Paragraph: styled.span`
    flex-grow: 1;
    color: ${({ theme }) => theme.palette.grey[800]};
    font-size: 0.75rem;
    line-height: 1.5;
  `,
};

const SelectTypePaper = ({ onSelect }) => (
  <S.Wrapper>
    <S.HelperText>
      <FormattedMessage {...messages.selectTypePaperHelperText} />
    </S.HelperText>
    <S.Flexbox>
      <S.Button variant="outlined" name="SINGLE_SELECTION" onClick={onSelect}>
        <S.RadioButtonChecked />
        <FormattedMessage {...messages.selectTypePaperButtonSingleSelection} />
      </S.Button>
      <S.Button variant="outlined" name="MULTIPLE_SELECTION" onClick={onSelect}>
        <S.CheckBox />
        <FormattedMessage {...messages.selectTypePaperButtonMultipleSelection} />
      </S.Button>
      <S.Button variant="outlined" name="DESCRIPTIVE" onClick={onSelect}>
        <S.Notes />
        <FormattedMessage {...messages.selectTypePaperButtonDescriptive} />
      </S.Button>
      <S.Button variant="outlined" name="SIGNATURE" onClick={onSelect}>
        <S.BorderColor />
        <FormattedMessage {...messages.selectTypePaperButtonSignature} />
      </S.Button>
    </S.Flexbox>
    <S.Note>
      <S.InfoOutlined />
      <S.Paragraph>
        <FormattedMessage {...messages.selectTypePaperNote} />
      </S.Paragraph>
    </S.Note>
  </S.Wrapper>
);

SelectTypePaper.propTypes = {
  onSelect: PropTypes.func,
};

SelectTypePaper.defaultProps = {
  onSelect: () => {},
};

export default SelectTypePaper;
